import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MiamiIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.9888 17.5564C10.9888 18.0351 10.6104 18.4004 10.1437 18.4004C9.69069 18.4004 9.29871 18.0225 9.29871 17.5564V6.57007H10.9888V17.5564Z",
                fill: "#00C875"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.20411 6.23953L2.10501 1.64353C2.10501 1.64353 5.56647 0.888388 8.15936 2.84227C9.07015 3.5286 9.64402 4.37607 10.0053 5.18677C10.3666 4.37607 10.9404 3.5286 11.8512 2.84227C14.4441 0.888388 17.9056 1.64353 17.9056 1.64353L11.8099 6.23694C12.5253 6.10521 13.3298 6.08705 14.1901 6.28566C17.3535 7.016 19 10.153 19 10.153L10 8.07521L1 10.153C1 10.153 2.64651 7.016 5.80995 6.28566C6.67587 6.08575 7.48523 6.10546 8.20411 6.23953Z",
                fill: "#00C875"
            })
        ]
    });
